import { render, staticRenderFns } from "./Kuli.vue?vue&type=template&id=23324fc0&scoped=true&"
import script from "./Kuli.vue?vue&type=script&lang=js&"
export * from "./Kuli.vue?vue&type=script&lang=js&"
import style0 from "./Kuli.vue?vue&type=style&index=0&id=23324fc0&prod&scoped=true&lang=css&"
import style1 from "./Kuli.vue?vue&type=style&index=1&id=23324fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23324fc0",
  null
  
)

export default component.exports